import type { SelectChangeEvent } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Gender } from 'config/enums';
import type { SelectItem } from 'features/ui/elements';
import { Select } from 'features/ui/elements';

interface SelectGenderProps {
  value: Gender;
  onChange: (event: SelectChangeEvent<Gender>) => void;
  className?: string;
}

export const SelectGender: FC<SelectGenderProps> = (props) => {
  const { t } = useTranslation();
  const options: SelectItem[] = [
    {
      text: t('unspecified'),
      value: String(Gender.U),
    },
    {
      text: t('male'),
      value: String(Gender.M),
    },
    {
      text: t('female'),
      value: String(Gender.F),
    },
  ];

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    props.onChange(event as SelectChangeEvent<Gender>);
  };

  return (
    <Select
      {...props}
      data-testid='select-gender'
      value={String(props.value)}
      options={options}
      onChange={handleChange}
    />
  );
};
